import { configureStore } from "@reduxjs/toolkit";
import farmerReducers from "../Components/farmer/FarmerSlice";
import inventoryReducers from "../Pages/Inventory/InventorySlice";
import contractorReducers from "../Pages/ContractorDashboard/ContractorSlice";
import authReducers from "./auth/AuthSlice";
import companyReducers from "./company/CompanySlice";
import productsReducers from "./product/ProductSlice";
import plannerReducers from "../Pages/PlannerDashboard/PlannerSlice";
import programsReducers from "./program/ProgramSlice";
import commodityReducers from "./commodity/CommoditySlice";
import auditorReducers from "../Pages/AuditorDashboard/AuditorSlice";
import certifierReducers from "../Pages/CertifierDashboard/CertifierSlice";
import TCL1AdminReducers from "../Pages/TransactionCertificateAdmin/TCL1Approver/TCL1AdminSlice";
import TCL2AdminReducers from "../Pages/TransactionCertificateAdmin/TCL2Approver/TCL2AdminSlice";
import procurementApprovalReducer from "../Pages/ProcurementApproval/ProcurementApprovalSlice";
import procurementReducers from "../Components/procurement/ProcurementSlice";
import TransactionCertificateReducers from "../Pages/TransactionCertificate/TransactionCertificateSlice";

const store = configureStore({
  reducer: {
    farmers: farmerReducers,
    contractor: contractorReducers,
    auth: authReducers,
    inventory: inventoryReducers,
    products: productsReducers,
    planner: plannerReducers,
    programs: programsReducers,
    commodity: commodityReducers,
    auditor: auditorReducers,
    certifier: certifierReducers,
    TCL1Admin: TCL1AdminReducers,
    TCL2Admin:  TCL2AdminReducers,
    procurementApproval: procurementApprovalReducer,
    company: companyReducers,
    procurement: procurementReducers,
    transactionCertificateClient:TransactionCertificateReducers,
  },
});

export default store;
